import React from 'react';
import { connect } from 'react-redux';
import { showModal } from '../../../actions/modal.js';
import { signInCheck } from '../../common/CheckUserStatus';
import wishlistStatusCodes from '../../../utils/wishlistStatusCodes';

const {
  ITEM_ADDED_TO_WISHLIST = '',
  ITEM_ALREADY_EXIST_IN_WISHLIST = '',
  ITEM_DELISTED_FROM_SITE = ''
} = wishlistStatusCodes;

class WishlistPopup extends React.Component {
  render() {
    let { wishlistStatus, newDesignLuxe } = this.props;
    let isSignedIn = signInCheck();
    if (wishlistStatus === ITEM_ADDED_TO_WISHLIST) {
      return (
        <div className="small-popup login-closet">
          <div className={newDesignLuxe ? 'ic-toparw' : 'ic-toparw ic-toparw-mr'} />
          <div className="popup-inner sm-width">Item saved in my wishlist</div>
        </div>
      );
    } else if (wishlistStatus === ITEM_ALREADY_EXIST_IN_WISHLIST) {
      return (
        <div className="small-popup login-closet">
          <div className={newDesignLuxe ? 'ic-toparw' : 'ic-toparw ic-toparw-mr'} />
          <div className="popup-inner sm-width">The item is already part of your wishlist</div>
        </div>
      );
    } else if (
      !(wishlistStatus >= ITEM_ADDED_TO_WISHLIST && wishlistStatus <= ITEM_DELISTED_FROM_SITE) &&
      !isSignedIn
    ) {
      return (
        <div className="small-popup login-closet">
          <div className={newDesignLuxe ? 'ic-toparw' : 'ic-toparw ic-toparw-mr'} />
          <div className="popup-inner">
            <span
              onClick={() => {
                this.props.showModal('sign-in-up');
              }}
              className="wishlist-login"
            >
              SIGN IN
            </span>
            <div className="wishlist-msg">To add or view item(s) part of your wishlist </div>
          </div>
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = state => {
  return {
    wishlistStatus: state.popup.wishlistStatus
  };
};

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => {
      dispatch(showModal(name, config));
    }
  };
};

export default WishlistPopup = connect(mapStateToProps, mapDispatchToProps)(WishlistPopup);
